import { type SearchValues, useAssignQueryParameter, useUpdateQueryParams } from '@pba/react-router';
import { useCallback, useMemo } from 'react';
import type { TransactionResultParams } from 'features/transactions';
import { TransactionResultParameter } from './transaction-result-parameter';

type P = {
  transactionResultKey?: string;
};

export const useGiveTransactionParams = ({
  transactionResultKey = 'transaction_result',
}: P = {}): TransactionResultParams => {
  const updateQueryParams = useUpdateQueryParams();
  const { resetValue: resetTransactionResult, value: transactionResult } = useAssignQueryParameter(
    transactionResultKey,
    TransactionResultParameter,
  );

  const onModalClose = useCallback(() => {
    const urlUpdates: SearchValues = {};
    resetTransactionResult(urlUpdates);
    updateQueryParams({ navigateOptions: { replace: true }, urlUpdates });
  }, [resetTransactionResult, updateQueryParams]);

  return useMemo(
    () => ({
      onModalClose,
      transactionResult,
    }),
    [transactionResult, onModalClose],
  );
};
